export class DocumentLibraryConstants {
  // Constants
  public static readonly Document_Slider_Open: string = 'isDocumentSliderOpen';
  public static readonly Internal_Client_Contact_Limited_Access: string = 'isInternalClientContactLimitedAccess';
  public static readonly PeriodicReviewCycle_NotApplicable_OptionValue: number = 6;
  public static readonly PeriodicReviewCycle_UserDefined_OptionValue: number = 5;  
  public static readonly DocumentLibraryTitle = 'Document Library';
  public static readonly DocumentDetailsTitle = 'Document Details';
  public static readonly MyAssignAdminTitle = 'My Assigned Admin';
  public static readonly ChangeRequest_PanelListType = 'CRI';
  public static readonly QaReview_PanelListType = 'assignedQas';
  public static readonly DocApprovals_PanelListType = 'approvers';
  public static readonly DocFormattings_PanelListType = 'assignedDocControls';
  public static readonly AssignedAdmin_PanelListType = 'assignedAdmins'
  public static readonly DocCollaborator_PanelListType = 'collaborators';
  public static readonly DocLibrary_PanelListType = 'docLibrary';
  public static readonly InternalClientContacts_PanelListType = 'internalClientContacts';
  public static readonly DocumentApprovePhase_OptionValue: number = 6;
  public static readonly Document_Phase_ClientSignature: string = 'Client Signature';
  public static readonly Document_Default_DocumentPhase: string = '1';
  public static readonly Document_Default_DocumentVersion: string = '0';
  public static readonly Document_Formatting_PhaseValue: number = 2;
  public static readonly Document_InReview_PhaseValue: number = 3;
  public static readonly Add_Edit_DocumentFormControls_Disabled_ByDefault = ['category', 'operationalGroup', 'author', 'assignedAdmins', 'collaborators', 'assignedDocControl', 'reviewers', 'approvers', 'periodicReviewers', 'assignedQAs','forbidChangesAfterInReviewTransition'];
  public static readonly Add_Edit_DocumentFormDocumentControls_Enabled_ByDefault = ['effectiveDate', 'periodicReviewDate', 'includeQAReview', 'convertToPdf', 'division', 'functionalArea', 'documentType'];
  public static readonly Assignment_types = {
    Acknowledgement: 1,
    AssignedAdmins: 2,
    AssignedDocControl: 3,
    AssignedQA: 4,
    Collaborator: 5,
    HardcopyActivity: 6,
    QualifiedTrainer: 7,
    PeriodicReviewer:8 

  };
  public static readonly ReasonHeading : string ='Reason for Change';
  public static readonly ReasonValidationMessage : string ='Reason is required';
  public static readonly ReasonForChangingEffectiveDateValidationMessage : string ="Reason For Changing Effective Date "

  //PlaceHolders

  public static readonly DocumentSearch_Place_Holder_Text: string =
    'Search by Title, Document # or Legacy Document #';

  // confirmation Messages
  public static readonly Document_Slider_Confirmation_Header: string =
    'Confirmation';
  public static readonly Document_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';
    public static readonly Document_Slider_Confirmation_Text_For_Approved_Or_EffectivePhase: string =
    'Changing the eQMS record could have unintended consequences and result in the eQMS record details differing from the Document File. Do you want to proceed?';

  public static readonly Document_Slider_File_Delete_Header: string =
    'Confirmation';
  public static readonly Document_Slider_File_Delete_Text: string =
    'Are you sure that you want to delete the file?';
  public static readonly Info_For_IncludeQAReview_Text: string =
    'If yes, the Document workflow will include a step for QA Review (performed by the Assigned QA User(s))'

    public static readonly Info_For_IncludesClientContact_Text: string =
    'If yes, the Document workflow will include a step for Client signature (performed by the Internal Client Contact(s))'

  public static readonly Deleted_Attachments_Confirmation_Message: string =
    'You are about to delete the following attachments. This action is not reversible. Do you want to proceed?'
    public static readonly Deleted_ClientSignatureAttachment_Confirmation_Message: string =
    'You are about to delete the following Client Signature Attachment. This action is not reversible. Do you want to proceed?'

  public static readonly Delete_SourceFile_WithTemplate_ConfimationMessage: string =
    'You are about to delete the File from the Document. The current File will be lost. Do you want to proceed?';

  public static readonly SwitchTabs_SourceFile_ConfirmationMessage: string =
    'With this action, the current File will be lost. Do you want to proceed?';
  public static readonly RelatedDocuments_Delete_ConfirmationMessage: string =
    'You are about to delete the related documents.Confirm?';
  public static readonly RelatedDocuments_Not_Aligned_With_Scope_ConfirmationMessage: string =
    `This Related Document is associated 
    with a different eQMS Scope than the current Document. Users may not be able to view this Related 
    Document based on their particular eQMS Scope access. Do you wish to continue and link the Related Document?`;

    public static readonly DocumentProficiencyQuiz_Slider_Confirmation_Header: string =
    'Confirmation';
    public static readonly DocumentProficiencyQuiz_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    public static readonly UpdateEffectiveDate_ConfirmationText : string = "Changing effective date will update the corresponding document which could have unintended downstream consequences (e.g., Training, Acknowledgements, etc.). Do you want to proceed?"

  // Toaster Messages and Severity
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Info: string = 'info';
  public static readonly Severity_Err: string = 'error';
  public static readonly Severity_Warning: string = 'warn';
  public static readonly Document_Created_Success: string =
    'Document Created Successfully';
  public static readonly Document_Save_Processing_Text: string =
    'Document save in progress';
  public static readonly Document_Updated_Success: string =
    'Document Updated Successfully';
  public static readonly MoveToPreviousPhase_Success: string =
    'Document Version has been moved to the previous phase successfully';
  public static readonly MoveToNextPhase_Success: string =
    'Document Version has been moved to the next phase successfully';
    public static readonly MoveToNextPhaseFormattedFileGeneration_Inprogress: string =
    'Formatted File generation is in progress.';
    public static readonly MoveToNextPhaseFormattedFileGenerationStatusCheck_Failure: string =
    'Document Version has been moved to the next phase successfully. Formatted File generation in progress. Kindly wait for the availability of formatted file.';
    public static readonly RetryDelayMsToCheckFormattedFileStatus = 2000;
    public static readonly MaxAttemptsToCheckFormattedFileStatus = 5;
  public static readonly DocumentReviewStatusUpdated_Success: string =
    'Document Version Review Updated Successfully';
  public static readonly MoveToVariousPhase_Success: string =
    'Document Version has been moved to the required phase successfully';
    public static readonly DeactivateDocumentVersion_Success: string =
    'Document Version has been moved to the Obsolete phase successfully';
    public static readonly DeactivateReason_Message: string = 
    "You must enter the reason why the Document Version is sent to Obsolete phase";
    public static readonly MoveToCancelledPhase_Success: string =
    'Document Version has been moved to the Cancelled phase successfully';
    public static readonly MoveToCollaborationPhase_Success: string =
    'Document Version has been moved to the Collaboration phase successfully';
    public static readonly FileCheckoutDiscarded_Success:string= 
    'The document is unlocked successfully';
    public static readonly DocumentSearch_Error_Message:string= 
    'Error in fetching search results';
    public static readonly DocumentSearchEmpty_Filters:string=
    'At least one search criterion must be defined';
    public static readonly SourceFileCheckIn_Success:string= 
    'The Source file checked in successfully';
  public static readonly ApprovedForApprover_Success: string =
    'Document Version approved for the Approver';
  public static readonly PeriodicReviewCycle_NotAllowed: string =
    'Periodic Review Date is not reset as Periodic Review Cycle is User Defined/ Not Applicable';
public static readonly FileCheckOutToasterMessage:string= 
'The file is now locked for you and available to edit. Be sure to check the file in when complete. eQMS will automatically unlock this file in 12 hours. If you have changes in the file that are not checked in at this time, they will be lost.';
public static readonly FileUnlockConfirmationMessage:string= 'You are about to unlock the Document Version. Any modification made to the source file during the Check Out will not be uploaded in eQMS. Do you want to proceed?'
  public static readonly Document_Proficiency_Quiz_Saved_Success: string =
  'Document Proficiency Quiz Saved Successfully';
  public static readonly DocumentQuiz_UpdateTrainingPlan_FailMessage: string = 'A technical error occurred and your training was not recorded in your training plan. Please retry and if this error persists, report it to your support contact.';

  public static readonly EffectiveDate_Updated: string =
  'Effective Date has been updated successfully';

  public static readonly PeriodicReviewDate_Updated: string =
  'Periodic Review Date has been updated successfully';

  public static readonly EffectiveAndPeriodicReviewDate_Updated : string = 
  'Effective Date and Periodic Review Date have been updated successfully'
  // Error Messages
  public static readonly Document_Title_Required: string = 'Title is required.';
  public static readonly Document_Phase_Required: string = 'Phase is required.';
  public static readonly Document_Division_Required: string =
    'Division is required.';
  public static readonly Document_FunctionalArea_Required: string =
    'Functional Area is required.';
  public static readonly Document_DocumentType_Required: string =
    'Type is required.';
  public static readonly Document_Reviewers_Required: string =
    'Reviewer(s) is required.';
  public static readonly Document_Approvers_Required: string =
    'Approver(s) is required.';
  public static readonly Document_Version_Required: string =
    'Version is required.';
  public static readonly Document_PeriodicReviewCycle_Required: string =
    'Periodic Review Cycle is required.';
  public static readonly Document_Author_Required: string =
    'Author is required.';
  public static readonly Document_location_Required: string =
    'eQMS Scope(s) is required.';
  public static readonly Document_Admin_Required: string =
    'Assigned Admin is required.';
  public static readonly Document_securityPermission_Required: string = 
    'Security/Permission(s) is required.';
  public static readonly Document_assignedQAs_Required: string = 
    'Assigned QA(s) is required.';
    public static readonly Document_assignedDocControl_Required: string = 
    'Assigned Doc Control(s) is required.';    
    public static readonly Document_internalClientConact_Required: string = 
    'Internal Client Contact(s) is required.';
    public static readonly Document_confidentialityLevel_Required: string = 
    'Confidentiality Level is required.';
  public static readonly Document_ReadyForApproval_EffectiveDateRequired: string = 
    'Effective Date is required.';
  public static readonly Document_ReadyForApproval_PeriodicDateRequired: string = 
    'Periodic Review Date is required.';
  public static readonly Document_PeriodicReviewer_Rquired: string = 
    'At least one Periodic Reviewer must be assigned';
  public static readonly PreviousPhase_ReasonForChange_Required: string =
    'Please enter the reason';
  public static readonly PreviousPhase_Phase_Required: string =
    'Please select the phase';
  public static readonly MoveToCancelledPhase_Reason_Required: string =
    'Please enter the reason';
  public static readonly PeriodicReviewDate_PastDate: string =
    'Periodic Review Date must be after Effective Date';
  public static readonly DocumentTemplate_Selection_Required: string =
    'A Document Source File must be uploaded.';
    public static readonly File_Check_In_Message: string =
    "After you check in the Document Version, your check out will be over and the Document Version will be available for modification to other users. Upload the updated source file you want to check in below. If you have not done any update to the Source File during your Check Out, you can use the Unlock Document button to end your Check Out without uploading a new Source File."
    public static readonly Document_ClientSignatureAttachment_Required: string =
    'Client Signature Attachment must be uploaded.';
    public static readonly DocumentSourceFile_Needs_To_Be_Uploaded: string =
    "You need to upload a new Source File to Check In. If you have not done any update to the Source File during your Check Out, you can use the Unlock Document button to end your Check Out without uploading a new Source File."

  public static readonly Document_ErrorText: string =
    'Please correct the following errors to save the Document.';

  public static readonly DocumentTemplate_Dropdown_IsEmpty: string =
    'There are no templates available for your eQMS Scope. Please select No Template and upload a Document File to move forward. If a template is required for this Document, it must first be created in Document Template.'

  public static readonly RelatedDocuments_Self_Linking_ErrorMessage: string =
    'It is not possible to link a Document to itself';
  public static readonly RelatedDocuments_Already_Linked_With_Single_DocumentNumber_ErrorMessage: string =
    'The Document Document_Number is already a Related Document,it is not possible to add it again.';
  public static readonly RelatedDocuments_Already_Linked_With_Multi_DocumentNumbers_ErrorMessage: string =
    'The Documents Document_Numbers is already part of Related Documents,it is not possible to add it again.';
  public static readonly Document_ApproverReviewerValidation_ErrorMessage: string = 
    'The Reviewer and Approver fields cannot be exactly the same.';
  public static readonly Document_ReviewerChangeAfterFormatting_ErrorMessage: string =
    'Reviewers cannot be modified after the Formatting Phase';
  public static readonly Document_ApproverChangeAfterReviewPhase_ErrorMessage: string = 
    'Approvers cannot be modified after the In Review Phase';

  public static readonly Document_Proficiency_Quiz_Min_Passing_Score_Required : string =
  "Minimum Passing Score is required"
  public static readonly Document_Proficiency_Quiz_Section_Required : string =
  "Quiz Section is required"
  public static readonly Document_Proficiency_Quiz_ErrorText: string =
    'Please correct the following errors.';

  public static readonly Document_Lookup_Data_Fetch_ErrorText: string =
    'Failed to load Document lookup data.';
  

  public static readonly Document_ReasonForChangingEffectiveDate : string = 'Reason for Changing Effective Date is required';
  public static readonly Document_File_NotAvailableToDownload : string = 'No file exists for this Document'
  public static readonly Document_File_UnableToDownload : string = 'A Technical error occurred and the document file could not be downloaded. Please contact technical support if this error persists.'
  public static readonly Document_PreviewFormattedFile_Failed : string = 'A Technical error occurred and the document file could not be generated. Please contact technical support if this error persists.'
  public static readonly File_Upload_Failed : string = 'A Technical error occurred and the Name was not uploaded. Please contact technical support.'
  public static readonly File_Generation_Failed : string = 'A Technical error occurred and the Document Formatted File was not generated. Please contact technical support.'
  public static readonly DocumentSourceFile_Creation_Failed : string = 'A technical error occurred and the Document File was not generated. Please select Edit and add a Template/Document file again. If this error persists, report it to your support contact.'
  public static readonly Document_File_Availability_Status_Information :string = 'Document File might take a little longer to be available,  please wait and retry again.'

  //Spinner Messages
  public static readonly Document_Save_InProgress: string =
    'Document Save is in progress';
  public static readonly Document_Update_InProgress: string =
    'Document Update is in progress';

  public static readonly Pending_Phase_Constant: string = 'Pending';
  public static readonly UserDefined_Peridic_Review_Cycle: string =
    'User Defined';
  public static readonly NotApplicable_Peridic_Review_Cycle: string =
    'Not Applicable';
  public static readonly Document_Proficieny_Quiz_Details_Loading: string =
    'Document Proficiency Quiz is loading';
  public static readonly Document_Proficieny_Quiz_Save_Progress: string =
    'Document Proficiency Quiz Save is in progress';
  public static readonly Document_Proficieny_Quiz_Uodate_Progress: string =
    'Document Proficiency Quiz Update is in progress';

  // Document Slider Menu Tab Indexes
  public static readonly Document_Menu_General_Tab_Index: number = 0;
  public static readonly Document_Menu_File_Tab_Index: number = 1;
  public static readonly Document_Menu_RelatedDocuments_Tab_Index: number = 2;

  public static readonly Document_Menu_File_Tab_Index_GlobalDocument: number = 0;
  public static readonly Document_Menu_RelatedDocuments_Tab_Index_GlobalDocument: number = 1;


  // Files
  public static readonly Document_File_Max_Size: number = 100;
  public static readonly Document_File_Attachments_Header_Text: string =
    'Attachments are files that are not directly managed in eQMS. These attachments are available to Users from the Document details and should be used as additional information, if necessary. This is not the official Document File.';
    public static readonly Document_ClientSignatureAttachment_HeaderText : string = 'This is the Document signed by the client. Only PDF files are allowed.'
  public static readonly Document_ClientSignatureAttachment_Max_Size : number = 100;
  public static readonly Document_ClientSignatureAttachment_MaxLimit : number = 1;
  public static readonly Document_Attachments_Max_Limit:number = 100;

  public static readonly Document_Source_File_Header_Text: string = 'The Document Source File is the official file. There can be only one Document Source File, and the User can choose to start with an existing Document Template or upload a file. This file will be editable by Users assigned to the Document Version (see Assignments/Permissions panel of the Document Info tab).'

  public static readonly DocumentTemplate_UploadFolder: string = 'documentTemplateUploadTemplate';

  public static readonly DocumentSourceFile_OriginType_Template: number = 0;
  public static readonly DocumentSourceFile_OriginType_NoTemplate: number = 1;
  public static readonly Document_Template_File_Max_Limit: number = 1;
  public static readonly Document_Template_File_Types: string =".xlsx,.xlsm,.doc,.docm,.docx,.pdf,.ppt,.pptm,.pptx";
    public static readonly Document_Attachments_File_Types: string =
    '.pdf, .xls, .xlsx, .xlsm, .doc, .docx, .docm, .ppt, .pptx, .txt, .jpeg, .png, .zip, .7z'

  public static readonly DocumentTemplate_DropDownBinding_ValueField: string = 'documentTemplateId';
  public static readonly DocumentTemplate_DropDownBinding_LabelField: string = 'documentTemplateName';
  public static readonly DocumentTemplate_SelectionButton_NgModelValue_Template: string = 'Template';
  public static readonly DocumentTemplate_SelectionButton_NgModelValue_NoTemplate: string = 'No Template';

  public static readonly Info_For_ConvertToPdf_Text: string =
    'If yes, the Document File will be converted to a PDF for Reviewers and Approvers, and remain a PDF once Approved and Effective.'

    public static readonly Info_For_Merge_ClientSignature_Attachment_Text: string =
    '"If yes, the Client Signature File attachment will be appended to the Document File after the last page. Note: This file must be a PDF and Convert to PDF must be true.'


  public static readonly ToolTipMessage_ToRemoveFromFavorite: string = 'Click to remove from Favorites';
  public static readonly ToolTipMessage_ToAddToFavorite: string = 'Click to add to Favorites';
  public static readonly ToolTipMessage_InActiveIcon: string = 'By default Document Versions with Phases Archived, Obsolete or Cancelled are not displayed. Check this check box to display them.';
  public static readonly ShowInActive_Label: string = 'Show Inactive';

  // Slider Titles
  public static readonly Document_Proficiency_Quiz_Title: string = 'Proficiency Quiz';

  //Confirmation Message
  public static readonly DocumentTraining_ConfirmationMessage: string = "I acknowledge that I have read this Document and that I understand it. I also understand that my training records will be updated accordingly and this Document will be removed from my Training Plan.";
  public static readonly DocumentTraining_ButtonLabel: string = "I Have Completed Training on this Document"

  public static readonly DocumentQuizCompletion_ConfirmationMessage:string="I acknowledge that I have read and understood this Document. The training for this Document will be marked as Complete only with a passing score within the maximum number of allowed attempts ({0}), and the Training Plan will be updated accordingly.";

  //Training tab
  public static readonly DocumentTraining_UpdatedSuccessfully: string = "Training Plan has been updated successfully."

  //Button labels
  public static readonly DocumentTraining_ButtonLabel_WithQuiz: string = "Take Proficiency Quiz";
  public static readonly DocumentTraining_QuizMaximumAttempts_Unlimited : string = "Unlimited";

  //Filter labels
  
  public static readonly Document_Search_Text: string = "searchText";  
  public static readonly Document_Search_Phase_Text: string = "phases";

  //E-Signature Confirmation popup texts 
  public static readonly Doc_Version_Review_Confirmation_Message: string = "I hereby declare that I have performed this review accurately as per the applicable procedure";  
  public static readonly Doc_Version_Approval_Confirmation_Message: string = "I hereby declare that I have performed this approval accurately as per the applicable procedure";  

  // features
  public static readonly Document_Feature: string = 'document';

  //Document Not found errors
  public static readonly NoDocumentFoundError =	'No Document';
  public static readonly NoDocumentVersionFoundError =	'No Document Version';
  public static readonly NoEffectiveVersionFoundError =	'No Effective Version';

  public static readonly DocumentSourceFile = 'Document Source File';
  public static readonly DocumentAttachments = 'Document Attachment(s)';
  public static readonly ClientSignatureAttachment = 'Client Signature Attachment';

  public static readonly Info_For_ForbidChangesAfterInReviewTransition_Text: string =
    'Document Version Metadata and Quiz are not modifiable after Client Signature / In Review transition, except by the Assigned Admin.'

  public static readonly DocumentLibraryScreen : string = 'Document Library';
  public static readonly DocumentRelatedDocumentsTab : string = 'Document Related Documents';
  public static readonly DocumentViewerPermissionError : string = 'You do not have permissions to access';
  public static readonly DocumentViewer_Not_Found_Error : string = 'This Document does not exist.';
  public static readonly DocumentViewer_Downloading : string = 'Downloading document. Please wait...';
  public static readonly Document_Ready_For_Download : string = 'Your document is ready. Based on your browser settings, it will open in a new tab or be saved in your downloads.';

  //Document Comment
  public static readonly DocumentCommentCreationSliderHeader : string = 'Create Document Comment';
  public static readonly DocumentComment_ErrorText: string ='Please correct the following errors to save the Document Comment.';
  public static readonly DocumentCommentText_ErrorMessage : string = 'Comment Text is required';
  public static readonly DocumentComment_CreationSuccessMessage : string = 'Document Comment has been added successfully';
  public static readonly Document_Creation_Failed : string = 'Due to some technical isssue, the document was not saved. Please try again.';
  
  //Bulk User Replacement
  public static readonly BulkUserReplacementUpdate_Message: string = `You are about to update {noOfDocuments} Document Version(s). Do you want to proceed?`;
  public static readonly Error_BulkUserReplacement_ValidationOnLoggedInUser: string = `The following Documents were not updated because they do not belong to an eQMS Scope on which you have modification rights. {documentNumberAndTitle}. Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly Error_BulkUserReplacement_ValidationOnUserToAdd: string = `The following Documents were not updated because the selected User to Add does not belong to an eQMS Scope of the Document or its descendants. {documentNumberAndTitle}. Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly Error_BulkUserReplacement_ValidationOnUserToRemove: string = `The following Documents were not updated because the selected User to Remove was not found on all the selected assignment fields. {documentNumberAndTitle}. Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly Error_BulkUserReplacement_ValidationOnSelectedAssignmentsUnavailable: string = `The following Documents were not updated because the selected Assignments are not all available on the Documents. {documentNumberAndTitle}. Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly Error_BulkUserReplacement_ValidationOnPhaseOfDocumentVersion : string = `The following Documents were not updated because they are not in a Phase that is allowed for the Bulk User Replacement feature (allowed Phases: Collaboration, QA Review, Formatting, Effective). {documentNumberAndTitle} Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly Error_BulkUserReplacement_ValidationOnReviewerAndApproverBeingSame: string = `The following Documents were not updated because the Reviewer and Approver fields cannot have the same value. {documentNumberAndTitle} Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`
  public static readonly Error_BulkUserReplacement_ValidationOnAuthor : string = `The selected Documents {documentNumberAndTitle} were not updated because the Author field cannot have more than one user.`
  public static readonly BulkUserReplacementUpdate_Info_Message: string = `User replacement is proceeding. Based on record selection, this may continue running. If you are still working on this page, please re-run your search for an updated list of Documents.`;
  public static readonly Error_BulkUserReplacement_ValidationOnPhaseForReviewerAndApprover: string = `The following Documents were not updated because Reviewers or Approvers cannot be modified in the phase these documents are currently in (allowed phases: Collaboration, QA Review, Formatting). {documentNumberAndTitle}. Note: Other Documents selected for User replacement (if any) that are not listed above have been updated accordingly.`;
  public static readonly DocumentType_RelatedDocument:number = 0;
  public static readonly CourseType_RelatedDocument:number = 1;
}
